var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFbutton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3387ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.0164 19.3527v4.6473c7.8492 0 13.9573-7.5839 11.3885-15.82353-1.1417-3.59237-3.996-6.47196-7.5924-7.583886-8.22019-2.565974-15.8125 3.563856-15.8125 11.404316h4.65243c0-4.90384 4.88077-8.7243 10.07547-6.84258 1.9124.68426 3.4537 2.22385 4.1387 4.13408 1.8838 5.189-1.9124 10.0643-6.8502 10.0643z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.3916 19.3811h4.6239v-4.6188h-4.6239z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.39187 22.945h-3.56782v-3.5637l3.56755-.0002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.828019 19.3813h2.968421v-2.9652h-2.968421z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbutton);
export default __webpack_public_path__ + "static/media/fbutton.06e279b509862f11da0916ef3dea3d4e.svg";
export { ForwardRef as ReactComponent };